export const getters = {
  getUser (state) {
    return state.user
  },
  getError (state) {
    return state.error
  },
  getLoading (state) {
    return state.loading
  },
  getLoadingDescript (state) {
    return state.loadingDescript
  },
  // KAN-95 暗室暗色主題（'light' | 'dark'）
  getUiTheme (state) {
    return state.ui.theme
  },
  getSetting(state) {
    return state.setting
  },
  // 醫院別配置 getter
  getHospital(state) {
    return state.hospital
  },
  // 便捷 getter：取得醫院 features（預設值確保 backward compat）
  getHospitalFeatures(state) {
    return state.hospital ? state.hospital.features : {
      nhia_export: true,
      patient_id_required: true,
    }
  }
}